/**
 * Turning a picked `File` into what the upload routes take.
 *
 * The API is JSON end to end, so an image travels as a `data:` URL — the same
 * shape the scan pipeline accepts. It costs about a third in transfer, which is
 * nothing at a 2 MB ceiling.
 *
 * Not in the API client: reading a `File` is a browser concern and the client
 * takes a string. `backend-client` knows nothing about `FileReader`.
 */

/** Mirrors the server's limit, so an oversized file fails instantly rather than after the upload. */
export const MAX_IMAGE_BYTES = 2 * 1024 * 1024;

function readAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read that file."));
    reader.onload = () => resolve(String(reader.result));
    reader.readAsDataURL(file);
  });
}

/** Checks the size, then reads the file. Throws the sentence to show. */
export async function readImageFile(file: File): Promise<string> {
  if (file.size > MAX_IMAGE_BYTES) {
    throw new Error(`That image is ${Math.round(file.size / 1024)} KB. The limit is 2 MB.`);
  }
  return readAsDataUrl(file);
}
